module.exports = __webpack_public_path__ + "static/senior-2-fd1b96e07e879ed24125b49f67a0620e.png";